// src/pages/TemplatePages.jsx
import React from "react";
import { Box } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";

import TemplateHeader from "./TemplateHeader";
import TemplateList from "./TemplateList";
import TemplateModal from "./TemplateModal";

import {
    listTemplates,
    createTemplate,
    updateTemplate,
    deleteTemplate as apiDeleteTemplate,
    duplicateTemplate,
} from "../../infra/api/templateApi";

// ✅ enum do backend (string)
const TEMPLATE_TAGS = [
    "RESULTADO",
    "RELATORIO_ANALISE",
    "RELATORIO_MENSAL",
    "RELATORIO_SEMANAL",
    "COMPARATIVO",
];

// ✅ agora é tag único
const EMPTY_TEMPLATE = { name: "", version: "1.0", tag: null };

export default function TemplatePages() {
    const { tenant } = useParams();
    const navigate = useNavigate();

    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [q, setQ] = React.useState("");
    const [status, setStatus] = React.useState("all");

    const [modalOpen, setModalOpen] = React.useState(false);
    const [editing, setEditing] = React.useState(null);

    const fetchData = React.useCallback(async () => {
        setLoading(true);
        try {
            const data = await listTemplates({ q, status });
            setItems(data || []);
        } finally {
            setLoading(false);
        }
    }, [q, status]);

    React.useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleNew = () => {
        setEditing(null);
        setModalOpen(true);
    };

    const handleNewDoc = async () => {
        const created = await createTemplate({ name: "Sem título", version: "1.0", tag: null });
        navigate(`/${tenant}/templates/${created.id}/editor`);
    };

    const handleEdit = (tpl) => {
        setEditing(tpl);
        setModalOpen(true);
    };

    const handleOpenEditor = (tpl) => {
        navigate(`/${tenant}/templates/${tpl.id}/editor`);
    };

    const handleDuplicate = async (tpl) => {
        await duplicateTemplate(tpl.id);
        await fetchData();
    };

    const handleDelete = async (tpl) => {
        if (!window.confirm(`Excluir template "${tpl.name}"?`)) return;
        await apiDeleteTemplate(tpl.id);
        await fetchData();
    };

    const handleExportPdf = async (tpl) => {
        alert(`Stub: gerar PDF do template "${tpl.name}"`);
    };

    const handleSaveModal = async (form) => {
        const payload = {
            name: form?.name ?? "",
            version: form?.version ?? "1.0",
            tag: form?.tag ?? null,
            // se você editar status/fileUrl no modal, inclua aqui também
            // status: form?.status ?? undefined,
            // fileUrl: form?.fileUrl ?? undefined,
        };

        if (editing?.id) await updateTemplate(editing.id, payload);
        else await createTemplate(payload);

        setModalOpen(false);
        setEditing(null);
        await fetchData();
    };

    return (
        <Box sx={{ p: 2, maxWidth: 1200, mx: "auto" }}>
            <TemplateHeader
                value={q}
                onChange={setQ}
                onNew={handleNew}
                onNewDoc={handleNewDoc}
                status={status}
                onStatusChange={setStatus}
                total={items.length}
            />

            <TemplateList
                items={items}
                loading={loading}
                filterText={q}
                onEdit={handleEdit}
                onOpenEditor={handleOpenEditor}
                onDuplicate={handleDuplicate}
                onDelete={handleDelete}
                onExportPdf={handleExportPdf}
            />

            <TemplateModal
                open={modalOpen}
                initialValue={editing || EMPTY_TEMPLATE}
                tagOptions={TEMPLATE_TAGS}
                onClose={() => {
                    setModalOpen(false);
                    setEditing(null);
                }}
                onSave={handleSaveModal}
            />
        </Box>
    );
}
